import { EyeOutlined, EditOutlined, CopyOutlined, PlusOutlined, DeleteColumnOutlined, DeleteOutlined } from "@ant-design/icons";
import { Button, Card, Space, Tooltip, Modal, Form, Input, Select, Popconfirm, Checkbox } from "antd";
import { Link, useNavigate } from "react-router-dom";
import PageHeader from "../../view/pageheader";
import TableComponent from "../CustomComponents/TableComponent";
import {
   getEventList, updateEventOrder, resetSuccessFlag, updateEventStatus, addStationMaster, getStationMasterList,
   deleteStationMaster, updateStationMaster, updateEventLastStage
} from "../../store/reducer/eventSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import SearchComponent from "../CustomComponents/SearchComponent";
import SwalComponent from "../CustomComponents/SwalComponent";
import { toast } from "react-toastify";
import Loader from "../../fields/Loader/Loader";
import { DndContext, closestCenter } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy, arrayMove, useSortable } from '@dnd-kit/sortable';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import Swal from "sweetalert2";
import { CSS } from "@dnd-kit/utilities";
const { Option } = Select;


const Events = () => {
   const navigate = useNavigate();
   const dispatch = useDispatch();
   const [isChanged, setIsChanged] = useState(false);
   const [lastStageEventId, setLastStageEventId] = useState(false);
   const [stationMasterModal, setStationMasterModal] = useState(false); // for table
   const [selectedFinalStageId, setSelectedFinalStageId] = useState(null);
   const [stationFormModal, setStationFormModal] = useState(false); // for add/edit form
   const [selectedEvents, setSelectedEvents] = useState([]);
   const [form] = Form.useForm();
   const [editingStation, setEditingStation] = useState(null);
   const [selectedFinalStage, setSelectedFinalStage] = useState({});
   const [selectFinalStageEventId, setSelectFinalStageEventId] = useState(null);
   const [localTableData, setLocalTableData] = useState([]);
   const { eventListData, eventStatusSuccess, eventStatusError, eventStatusErrorMessage, eventLoading, addStationMasterSuccess,
      addStationMasterError, addStationMasterErrorMessage, StationMasterListData, updateStaionMasterSuccess, updateStaionMasterError, updateStaionMasterErrorMessage, deleteStationMasterSuccess,
      deleteStationMasterError, deleteStationMasterErrorMessage, updateEventLastStageSuccess, eventOrderSuccess
   } = useSelector((state) => state.events);
   const { count: totalCount, data: tableData, eventIds } = eventListData;
   const { count: stationMasterCount, data: stationMasterData } = StationMasterListData
   function getData(payload = {}) {
      dispatch(getEventList(payload));
      dispatch(getStationMasterList({ ...payload }))
   }
   useEffect(() => {
      getData();
   }, []);

   useEffect(() => {

      const formattedEvents = eventListData?.data?.map(event => ({
         id: event?.id,              // ID of the event
         eventname: event?.eventname, // Name of the event
         is_last_stage: event?.is_last_stage ? event?.is_last_stage : 0,
      })) || [];
      // reset({
      //    ...eventListData?.data,
      //    event_id: formattedEvents.map(event => event.id),
      // });
      setSelectedEvents(formattedEvents);

   }, [eventListData]);
   useEffect(() => {
      if (tableData?.length) {
         setLocalTableData(tableData);
      }
   }, [tableData]);

   const onDragEnd = ({ active, over }) => {
      if (active.id !== over?.id) {
         setLocalTableData((prev) => {
            const oldIndex = prev.findIndex(item => item.id === active.id);
            const newIndex = prev.findIndex(item => item?.id === over?.id);
            const newArray = arrayMove(prev, oldIndex, newIndex).map((item, idx) => ({
               ...item,
               serial_no: idx + 1, // update serial_no based on new index
            }));
            setIsChanged(true); // mark changed
            return newArray;
         });
      }
   };
   const SortableRow = (props) => {
      const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
         id: props["data-row-key"],
      });

      const style = {
         ...props.style,
         transform: CSS.Transform.toString(transform),
         transition,
         cursor: "move",
      };

      return <tr {...props} ref={setNodeRef} style={style} {...attributes} {...listeners} />;
   };



   const CheckboxOnchange = (eventId, currentChecked) => {
      const isChecked = !currentChecked; // toggle the clicked one
      setSelectedEvents((prevEvents) =>
         prevEvents.map((event) => ({
            ...event,
            is_last_stage: event.id === eventId && isChecked ? 1 : 0,
         }))
      );
      setLastStageEventId(currentChecked == false ? true : false);
      Swal.fire({
         title: 'Are you sure?',
         text: "You want to change the Final Event Stage!",
         icon: 'warning',
         showCancelButton: true,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'Yes, change it!'
      }).then((result) => {
         if (result.isConfirmed) {
            dispatch(updateEventLastStage({ editID: eventId }));
            // setSelectFinalStageEventId(eventId);
            // toast.success('Final Event Stage Updated successfully')
            // getData();
         } else {
            //  revert UI back if cancelled
            setSelectedEvents((prevEvents) =>
               prevEvents.map((event) => ({
                  ...event,
                  is_last_stage: event.id === eventId
                     ? (currentChecked ? 1 : 0)
                     : event.is_last_stage,
               }))
            );
         }
      });
      setSelectedFinalStageId(eventId);
   };


   useEffect(() => {
      if (eventStatusSuccess) {
         toast.success("Event status updated successfully");
         getData();
         dispatch(resetSuccessFlag({ flag: "eventStatusSuccess" }))
      }
      if (eventStatusError) {
         toast.error(eventStatusErrorMessage);
         dispatch(resetSuccessFlag({ flag: "eventStatusError" }))
      }
      if (updateEventLastStageSuccess) {
         toast.success('Final Event Stage Updated successfully')
         getData();
      }
      if (eventOrderSuccess) {
         toast.success("Event order updated successfully");
         getData();
      }

   }, [eventStatusSuccess, eventStatusError, eventStatusError, updateEventLastStageSuccess, eventOrderSuccess, dispatch])
   const columns = [
      {
         title: "Order No",
         dataIndex: "serial_no",
         key: "serial_no",
         align: "center",
      },
      {
         title: "Event Stages",
         dataIndex: "eventname",
         key: "event_name",
         align: "left",
         sorter: (a, b) => a.eventname.localeCompare(b.eventname),
      },

      {
         title: "Status",
         key: "status",
         align: "center",
         render: record => (
            <SwalComponent
               message="Are you sure you want to change the Event status?"
               onClickDispatch={updateEventStatus}
               id={record.id}
               status={true}
               statusValue={record.status}
               postData={{ status: record.status == 1 ? 0 : 1 }}
            />
         ),
         sorter: (a, b) => a.status - b.status,

      },
      {
         title: "Select Final Stage",
         align: "center",
         render: (data) => {
            // find the latest state for this row (important if table data is not auto-refreshed)
            const row = selectedEvents.find((e) => e.id === data.id) || data;

            return (
               <Tooltip title="Select Final Stage for this Event">
                  <Checkbox
                     // use onMouseDown since dnd-kit eats onChange
                     onMouseDown={() =>
                        CheckboxOnchange(data.id, row?.is_last_stage == 1)
                     }
                     checked={row?.is_last_stage === 1}
                  />
               </Tooltip>
            );
         },
         sorter: (a, b) => a.status - b.status,
      },
      // {
      //    title: "Box States",
      //    dataIndex: "box_states",
      //    key: "box_states",
      //    align: "center",
      //    render: (text) => {
      //       if (text == 1) {
      //          return <span className="text-warning">Awaiting Review</span>;
      //       } else if (text == 2) {
      //          return <span className="text-info">Waiting for Production</span>;
      //       }
      //       else if (text == 3) {
      //          return <span className="text-primary">To Production</span>;
      //       } else if (text == 4) {
      //          return <span className="text-success">Completed Production</span>;
      //       }
      //       else if (text == 5) {
      //          return <span className="text-danger">Awaiting Destruction</span>;

      //       } else {
      //          return <span className="text-secondary">N/A</span>;
      //       }
      //    },
      //    sorter: (a, b) => a.box_states - b.box_states,

      // },
      {
         title: "Action",
         key: "Action",
         align: "center",
         render: (data) => (
            <Space>
               {!eventIds.includes(data?.id) && (
                  <Tooltip title="Edit">
                     <Button
                        shape="circle"
                        className="border-0"
                        icon={<EditOutlined style={{ color: "blue" }} />}
                        onMouseDown={() => navigate(`/events/edit/${window.btoa(data?.id)}`)}
                     />
                  </Tooltip>
               )}

               {/* View Button */}
               {/* <Tooltip title="View">
                  <Button
                     shape="circle"
                     className="border-0"
                     icon={<EyeOutlined style={{ color: "green" }} />}
                     onClick={() => showModal(data)}
                  />
               </Tooltip> */}

               {/* Copy Button */}
               <Tooltip title="Copy">
                  <Button
                     shape="circle"
                     className="border-0"
                     icon={<CopyOutlined style={{ color: "green" }} />}
                     onMouseDown={() => navigate(`/events/edit/${btoa(data?.id)}?type=copy`)}
                  />
               </Tooltip>
            </Space>
         ),
      },
   ];
   const handleSubmitSortOrder = () => {
      const postData = localTableData.map((item) => ({
         id: item.id,
         serial_no: item.serial_no,
      }));
      dispatch(updateEventOrder({ postData }))
      setIsChanged(false)
      getData();
      // toast.success("Event order updated successfully");

   };


   // open add form
   const openAddStationModal = () => {
      setEditingStation(null);
      form.resetFields();
      setStationFormModal(true);
   };

   const openEditModal = (record) => {
      setStationFormModal(true);
      setEditingStation(record);
      form.setFieldsValue({
         stage_id: record.stage_id,
         station_number: record.station_number,
      });
      // setStationMasterModal(true);
   };

   const handleStationMasterSubmit = () => {
      form.validateFields()
         .then((values) => {
            const stage = tableData.find((e) => e.id === values.stage_id);

            const payload = {
               ...values,
               stage_name: stage?.eventname,
            };

            if (editingStation) {
               dispatch(updateStationMaster({ updateID: editingStation.id, postData: { ...payload } }));
            } else {
               dispatch(addStationMaster({ postData: payload }));
            }

            setStationFormModal(false);
            form.resetFields();
            getData();
         })
         .catch((errorInfo) => {
            // AntD gives detailed error info here

            // toast.error("Please fill in all required fields before submitting.");
         });
   };


   const handleDeleteStation = (id) => {
      dispatch(deleteStationMaster({ deleteID: id }));
   };

   // Station Master Table columns
   const stationColumns = [
      {
         title: "Stage Name",
         dataIndex: "stage_name",
         key: "stage_name",
      },
      {
         title: "Station Number",
         dataIndex: "station_number",
         key: "station_number",
      },
      {
         title: "Action",
         key: "action",
         align: "center",
         render: (record) => (
            <Space>
               <Tooltip title="Edit">
                  <Button
                     shape="circle"
                     className="border-0"
                     icon={<EditOutlined style={{ color: "blue" }} />}
                     onClick={() => openEditModal(record)}
                  />
               </Tooltip>

               <Popconfirm
                  title="Are you sure you want to delete this station?"
                  onConfirm={() => handleDeleteStation(record.id)}
                  okText="Yes"
                  cancelText="No"
               >
                  <Button
                     shape="circle"
                     className="border-0"
                     icon={<DeleteOutlined style={{ color: "red" }} />}
                     danger
                  >

                  </Button>
               </Popconfirm>
            </Space>
         ),
      },
   ];


   return (
      <div>
         <Loader loading={eventLoading} />
         <PageHeader HeaderText="Event Stages" Breadcrumb={[{ name: "Event Stages" }]} backButtonUrl="" />
         <Card style={{ marginTop: "-28px", }}
            title="Box Events Stages"
            extra={
               <>
                  {isChanged && (
                     <Button
                        className="btn-success mr-5"
                        shape="round"
                        onClick={handleSubmitSortOrder}
                     >
                        Submit Event Order
                     </Button>
                  )}
                  {/* {
                     lastStageEventId && <Button
                        className="btn-success mr-5"
                        shape="round" onClick={handleLastStageSubmit}>
                        Submit Last Stage Event
                     </Button>
                  } */}
                  <Space size={"middle"} className="my-3">
                     <Button onClick={() => navigate('/events/station-master')} className="primary-btn ml-2" shape="round">
                        Station Master

                     </Button>

                     <SearchComponent
                        placeHolder="Search Event Name"
                        onChange={e => {
                           const payloadData = {
                              query: e.target.value,
                           };
                           getData(payloadData);
                        }} />


                  </Space>
                  <Link to="/events/add">
                     <Button className="primary-btn ml-2" shape="round">
                        Add Event Stage
                     </Button>
                  </Link>
               </>
            }
         >
            <DndContext collisionDetection={closestCenter} modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
               <SortableContext items={localTableData?.map((item) => item?.id)} strategy={verticalListSortingStrategy}>
                  <TableComponent
                     columns={columns}
                     TotalDataCount={totalCount}
                     dataSource={localTableData}
                     rowKey="id"
                     size={"small"}
                     components={{ body: { row: SortableRow } }}
                     onChangeDispatch={getData}
                  />
               </SortableContext>
            </DndContext>



         </Card>
         <Modal
            // title="Station Master"
            open={stationMasterModal}
            onCancel={() => setStationMasterModal(false)}
            footer={null}
            width={800}
         >
            <div style={{ marginBottom: 16 }}>
               <Button icon={<PlusOutlined />} className="primary-btn" shape="round" onClick={openAddStationModal}>
                  Add Station Master
               </Button>
            </div>

            <TableComponent
               columns={stationColumns}
               TotalDataCount={stationMasterCount}
               dataSource={stationMasterData}
               rowKey="id"
               size="small"
               onChangeDispatch={getData}
            />
         </Modal>
         <Modal
            title={editingStation ? "Edit Station Master" : "Add Station Master"}
            open={stationFormModal}
            onCancel={() => setStationFormModal(false)}
            onOk={handleStationMasterSubmit}
            okText={editingStation ? "Update" : "Add"}
         >
            <Form layout="vertical" form={form}>
               <Form.Item
                  name="stage_id"
                  label="Select Event Stage"
                  rules={[{ required: true, message: "Please select Event stage" }]}
               >
                  <Select placeholder="Select Stage">
                     {tableData?.map((stage) => (
                        <Option key={stage.id} value={stage.id}>
                           {stage.eventname}
                        </Option>
                     ))}
                  </Select>
               </Form.Item>

               <Form.Item
                  name="station_number"
                  label="Station Number"
                  rules={[{ required: true, message: "Please enter station number" }]}
               >
                  <Input
                     type="number"
                     placeholder="Enter Station Number"
                     onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                           e.preventDefault(); // block non-numeric keys
                        }
                     }}
                  />
               </Form.Item>
            </Form>
         </Modal>
      </div>
   );
};

export default Events;
